import Vue from 'vue';
import { get } from 'lodash';
import tooltip from '@/components/Tooltip';
import FuseMppt from '@/jobs/calculators/string-fuse-mppt.vue';

const root = document.querySelector('#string-fuse-tool');

if (root) {
    new Vue({
        el: root,

        delimiters: ['${', '}'],

        components: {
            tooltip,
            FuseMppt
        },

        data: {
            job: JSON.parse(root.dataset.job),
            products: JSON.parse(root.dataset.products),
            configuration: JSON.parse(root.dataset.configuration)
        },

        computed: {
            temperature() {
                return get(this.job, 'details.temperature.min', NaN);
            },
        },
    });
}
